/**
 * Whether the camera is knocked about by gunfire.
 *
 * The shake is render-only and was never on the wire, so this changes the picture and nothing else:
 * the recoil that moves where rounds actually go is authored per gun in `sim/aim.ts` and is not
 * this. That is worth saying on the hint, because a player turning off a thing called "shake" has
 * every reason to think they are giving up accuracy for comfort, and they are not.
 *
 * One of the three under the master. On by default.
 */

import { DEFAULT_MOTION_EFFECT, setMotionEffect } from '@/core/motion/motionPreference';
import { SETTING_CAMERA_SHAKE_HINT, SETTING_CAMERA_SHAKE_LABEL } from '@/text/settingsText';
import { toggleApply, toggleValue } from '@/ui/settings/controls/toggleSwitch';
import type { SettingDefinition } from '@/ui/settings/settingContract';

export const CAMERA_SHAKE: SettingDefinition = {
  id: 'cameraShake',
  section: 'accessibility',
  label: SETTING_CAMERA_SHAKE_LABEL,
  hint: SETTING_CAMERA_SHAKE_HINT,
  control: { kind: 'toggle' },
  defaultValue: toggleValue(DEFAULT_MOTION_EFFECT),
  apply: toggleApply((on: boolean): void => {
    setMotionEffect('cameraShake', on);
  }),
};
